function sortObject(unordered) {
    var sortArrays = false;
    if (!unordered || typeof (unordered) !== 'object') {
        return unordered;
    }
    if (Array.isArray(unordered)) {
        var newArr = ko.utils.arrayMap(unordered, function(item) {
            return sortObject(item, sortArrays);
        });
        if (sortArrays) {
            newArr.sort();
        }
        return newArr;
    }

    var ordered = {};
    ko.utils.arrayForEach(Object.keys(unordered).sort(), function(key) {
        ordered[key] = sortObject(unordered[key], sortArrays);
    });
    return ordered;
}

function escapeHtml(unsafe) {
    return unsafe
        .replace(/</g, "&lt;")
        .replace(/>/g, "&gt;")
}

function unescapeHtml(safe) {
    return safe
        .replace(/&lt;/g, "<")
        .replace(/&gt;/g, ">")
}

function scrollTo(section) {
    if(section === "response") {
        // Remove loading animation
        document.querySelector('.loading-validator').classList.remove('d-block');
        // Go to validated result
        const targetPosition = document.querySelector("#validator-response").getBoundingClientRect().top + window.scrollY - 76;
        window.scroll({ top: targetPosition, behavior: 'smooth' });
    } else if (section === "top") {
        window.scroll({ top: 0, behavior: 'smooth' });
    }
}

ko.bindingHandlers.codemirror = {
    init: function(element, valueAccessor, allBindings, viewModel, bindingContext) {
        var options = viewModel.options || {};
        options.value = ko.unwrap(valueAccessor());
        element.editor = CodeMirror.fromTextArea(element, options);
        element.editor.on('change', function(cm) {
            var value = valueAccessor();
            value(cm.getValue());
        });
    },
    update: function(element, valueAccessor, allBindings, viewModel, bindingContext) {
        if(viewModel.allowSetValue()) {
            var observedValue = ko.unwrap(valueAccessor());
            if (element.editor) {
                element.editor.setValue(observedValue);
                element.editor.execCommand('goDocEnd');
                element.editor.refresh();
            }
        }
    }
};

var VM = function () {
    var self = this;
    var parser = new fxparser.XMLParser();

    self.working = ko.observable(false);
    self.showResult = ko.observable(false);
    self.input = ko.observable('');
    self.emptyInput = ko.pureComputed(function(){
        return self.input() === "";
    });
    self.tree = jsonTree.create({}, document.getElementById('json-tree-view'));
    self.xmlInput = ko.observable();
    self.jsonInput = ko.observable();
    self.status = ko.observable();

    self.options = { lineNumbers: true };
    self.allowSetValue = ko.observable(false);
    self.error = ko.observable('');
    self.errorLine = ko.observable();

    // XML View functions
    var defaultXmlOptions = {
        'indent_size': 4,
        'wrap_line_length': 0,
        'preserve_newlines': false
    };
    self.xmlTemplateOptions = ko.observableArray([
        { label: 'Compact', value: 0 },
        { label: 'One space', value: 1 },
        { label: 'Two spaces', value: 2 },
        { label: 'Three spaces', value: 3 },
        { label: 'Four spaces', value: 4 },
        { label: 'Five spaces', value: 5 },
        { label: '1 Tab', value: 'tab' }
    ]);
    self.selectedXmlTemplate = ko.observable(4);
    self.selectedXmlTemplate.subscribe(function(newValue){
        self.createCodeView(true);
    });
    self.xmlCodeViewerClass = ko.pureComputed(function() {
        return self.selectedXmlTemplate() === 0 ? 'minify' : '';
    });

    // Tree View functions
    self.expandTree = function() {
        self.tree.expand();
    }
    self.collapseTree = function() {
        self.tree.collapse();
    }
    self.jsonTemplateOptions = ko.observableArray([
        { label: 'Compact', value: 0 },
        { label: 'One space', value: 1 },
        { label: 'Two spaces', value: 2 },
        { label: 'Three spaces', value: 3 },
        { label: 'Four spaces', value: 4 },
        { label: 'Five spaces', value: 5 },
        { label: '1 Tab', value: 'tab' },
    ]);
    self.selectedJsonTemplate = ko.observable(4);
    self.jsonTreeViewerClass = ko.pureComputed(function() {
        return 'spaces-' + self.selectedJsonTemplate();
    });
    self.disableButtons = ko.pureComputed(function() {
        if(self.selectedJsonTemplate() === 0) {
            return true;
        }
        return false;
    });
    self.selectedJsonTemplate.subscribe(function(newValue){
        self.createTree();
    });
    self.sortObject = ko.observable(false);
    self.sortObject.subscribe(function(newValue) {
        self.createTree();
    });

    // Validate & Format button
    self.validate = function () {
        self.resetObservables();
        // Show loading animation
        document.querySelector('.loading-validator').classList.add('d-block');
        self.validateAndFormat();
    }

    self.validateAndFormat = function() {
        // Check if input is not empty & valid
        if(self.input()) {
            self.working(true);
            setTimeout(function() {
                if(fxparser.XMLValidator.validate(self.input()) === true) {
                    self.working(false);
                    self.showResult(true);
                    self.createCodeView();
                    self.createTree();
                    scrollTo('response');
                } else {
                    var error = fxparser.XMLValidator.validate(self.input());
                    self.error("Error: " + error.err.code + "\n" + "Line: " + error.err.line + ", Col: " + error.err.col + "\n" + "Message: " + error.err.msg);
                    self.errorLine(error.err.line);
                    document.querySelector('.textarea-codemirror textarea').editor.addLineClass(self.errorLine() - 1, "wrap", "mark");
                    self.status('Invalid XML');
                    self.working(false);
                    self.showResult(true);
                    scrollTo('response');
                    return;
                }
            }, 500);
        }
    }

    self.createCodeView = function() {
        if(self.selectedXmlTemplate() === 'tab') {
            self.xmlInput(html_beautify(self.input(), {'indent_size': 1, 'wrap_line_length': 0, 'preserve_newlines': false, 'indent_char': '\t' }));
        } else {
            self.xmlInput(html_beautify(self.input(), {'indent_size': self.selectedXmlTemplate(), 'wrap_line_length': 0, 'preserve_newlines': false }));
            if(self.selectedXmlTemplate() === 0) {
                var minify = self.xmlInput().replace(/\r?\n|\r/g, '');
                self.xmlInput(minify);
            }
        }

        document.querySelectorAll('#mySourceTabContent pre code.hljs').forEach((block) => {
            hljs.highlightBlock(block);
        });
    }

    self.createTree = function() {
        self.jsonInput(parser.parse(self.input()));
        var input = self.jsonInput();
        if(self.sortObject()) {
            input = sortObject(input);
        }

        if(self.selectedJsonTemplate() === 0) {
            document.getElementById('json-tree-view').innerHTML = unescapeHtml(JSON.stringify(input), null, 0);
            document.querySelectorAll('#json-tree-view').forEach((block) => {
                hljs.highlightBlock(block);
            });
        } else {
            document.getElementById('json-tree-view').innerHTML = "";
            self.tree.loadData(input);
            self.tree.appendTo(document.getElementById('json-tree-view'));
            self.tree.expand();
        }
        return;
    }

    self.resetObservables = function() {
        self.xmlInput('');
        self.status('');
        self.error('');
        if(self.errorLine()) {
            document.querySelector('.textarea-codemirror textarea').editor.removeLineClass(self.errorLine() - 1, "wrap", "mark");
            self.errorLine('');
        }
    }

    // Copy to clipboard button
    var copyCode = new ClipboardJS('.cpybutton', {
        target: function (evt) {
            const tabParent = document.querySelector(evt.getAttribute('data-bs-container'));
            if (tabParent.querySelector('.language-xml')) {
                return tabParent.querySelector('.language-xml');
            }
        },
        text: function (evt) {
            const tabParent = document.querySelector(evt.getAttribute('data-bs-container'));
            if (!tabParent.querySelector('.language-xml')) {
                if (self.selectedJsonTemplate() === "tab") {
                    return unescapeHtml(JSON.stringify(self.tree.sourceJSONObj, null, '\t'));
                }
                return unescapeHtml(JSON.stringify(self.tree.sourceJSONObj, null, self.selectedJsonTemplate()));
            }
        }
    });
    copyCode.on('success', function(evt) {
        evt.clearSelection();
        const cpyButton = new bootstrap.Tooltip(evt.trigger);
        cpyButton.show();
        setTimeout(() => cpyButton.hide(), 1000);
    });

    // Copy to clipboard for markdown button
    var mrkdCode = new ClipboardJS('#mrkdbutton', {
        text: function (evt) {
            const tabParent = document.querySelector(evt.getAttribute('data-bs-container'));
            if (tabParent.querySelector('.language-xml')) {
                return '```xml\n' + tabParent.querySelector('.language-xml').textContent + '\n```';
            }
        }
    });
    mrkdCode.on('success', function (e) {
        e.clearSelection();
        const mrkdButton = new bootstrap.Tooltip(document.querySelector('#mrkdbutton'));
        mrkdButton.show();
        setTimeout(() => mrkdButton.hide(), 1000);
    });

    self.shareToolbox = ko.pureComputed({
        read: function () {
            var url = encodeURIComponent(window.location.href),
                title = encodeURIComponent(document.title),
                description = encodeURIComponent(document.getElementsByName('description')[0].getAttribute('content'));
            
            return { 
                facebook: 'https://www.facebook.com/sharer.php?u=' + url,
                twitter: 'https://x.com/intent/tweet?url=' + url + '&text=' + title,
                linkedin: 'https://www.linkedin.com/sharing/share-offsite/?url=' + url,
                email: 'mailto:?subject=' + title + '&body=' + description + ' Link: ' + url
            };
        },
        owner: this
    });
}

document.addEventListener("DOMContentLoaded", function () {
    var vm = new VM();
    ko.applyBindings(vm, document.body);
});